module.exports = __webpack_public_path__ + "images/education-bg-1.d9da71ce.webp";